import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import moment from 'moment';

import { cooperplaceApi } from 'services/api';

import { useSnackbar } from 'v3/components/Snackbar';
import Text from 'v3/components/Text';

import { VehicleBodiesRegister as Register } from 'v3/pages/VehicleBodies/Register';
import { VehicleBodiesDetails as Details } from 'v3/pages/VehicleBodies/Details';
import { VehicleBodiesProvider } from './context';

export function VehicleBodiesShared() {
  const snackbar = useSnackbar();
  const params = useParams();
  const navigate = useNavigate();
  const [vehicleBody, setVehicleBody] = useState({});
  const [prevVehicleBody, setPrevVehicleBody] = useState(vehicleBody);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  function showSnackbar(text, options) {
    snackbar.show(<Text> {text} </Text>, options);
  }

  async function fetchVehicleBody() {
    try {
      setLoading(true);
      const response = await cooperplaceApi.get(`vehicleBodies/${params.id}`);
      let { data } = response;
      data = {
        ...data,
        color: { label: data?.color, value: data?.color },
        province: data?.plateState,
        city: {
          name: data?.plateCity,
          province: {
            uf: data?.plateState,
          },
        },
        brand: {
          id: data?.manufacturerId,
          name: data?.brand,
        },
        model: data?.model ? { label: data?.model } : null,
        anttType: { id: data?.anttTypes?.id, name: data?.anttTypes?.name },
        owner: {
          label: data?.ownerWagon?.socialName,
          cpfCnpj: data?.ownerWagon?.cpfCnpj,
          id: data?.ownerWagon?.id,
          socialName: data?.ownerWagon?.socialName,
        },
        beneficiary: {
          label: data?.beneficiaryWagon?.socialName,
          cpfCnpj: data?.beneficiaryWagon?.cpfCnpj,
          id: data?.beneficiaryWagon?.id,
          socialName: data?.beneficiaryWagon?.socialName,
        },
        anttAdherence: data?.anttAdherence
          ? format(
            new Date(moment(data?.anttAdherence).add(1, 'day')),
            'yyyy-MM-dd'
          )
          : null,
        bodyType: data?.bodyType,
      };
      setVehicleBody(data);
      setPrevVehicleBody(data);
      setLoading(false);
    } catch (error) {
      const message = error?.response?.data?.message || 'Não foi possível carregar essa carroceria';

      showSnackbar(message, {
        type: 'error',
      });

      setLoading(false);
      navigate('/carrocerias');
    }
  }

  useEffect(() => {
    if (params.id) {
      fetchVehicleBody();
    }
  }, [params.id]);

  function setData(data) {
    setVehicleBody(prev => ({ ...prev, ...data }));
  }

  function updatePrevVehicleBody(data) {
    setPrevVehicleBody(data);
  }

  function handleCancel() {
    setVehicleBody(prevVehicleBody);
  }

  return (
    <VehicleBodiesProvider
      value={{
        data: vehicleBody,
        setData,
        loading,
        errors,
        setErrors,
        handleCancel,
        updatePrevVehicleBody,
        showSnackbar,
        fetchVehicleBody,
        prevVehicleBody,
      }}
    >
      {params.id ? <Details /> : <Register />}
    </VehicleBodiesProvider>
  );
}
